/* ALBEUX SLIDE FIT v2 (2 Nov 2026). Pairs with albeux-slide.js. Loaded from snippets/view-transition-opt-in.liquid.
   v1 trimmed the swipe row and pulled the details up with a negative margin, a moment after the page had landed (and again after 0.45s, after 1.5s and after every swipe).
   Those late measurements moved the details while they were opening (a lift up or down) and, when a measurement was wrong, could pull the title up over the photograph.
   There is no product video any more, every photograph is a square, so the swipe row is already exactly one photograph tall and the details already sit right under it.
   That is now done by CSS alone (assets/albeux-pdp-tight.css), which is there from the first frame and never changes afterwards.
   This file therefore changes nothing on the page. It only clears anything v1 may have left behind on a page that is still open (an inline row height or an inline margin on the details).
   NOTHING ABOUT THE SLIDE ITSELF IS TOUCHED. */
(function () {
  'use strict';
  if (window.__albSlideFit) return;
  window.__albSlideFit = true;
  try {
    var m = document.getElementById('MainContent');
    if (!m) return;
    var rows = m.querySelectorAll('media-gallery slideshow-slides');
    for (var i = 0; i < rows.length; i++) { if (rows[i].__albSet) { rows[i].style.height = ''; rows[i].__albSet = false; } }
    var det = m.querySelector('.product-details');
    if (det) det.style.removeProperty('margin-block-start');
  } catch (e) {}
})();
